define('appkit/inject.mixin',[
  'underscore',
  './singleton.registry'
], function(
  _,
  SingletonRegistry
) {

  var splitter = /(^|:)(\w)/gi;

  var InjectMixin = {

    _initInject: function(inject) {
      var self   = this,
          _done  = null;

      inject = _.isArray(inject) ? inject : [];

      function done() {
        if (self.triggerMethod) {
          self.triggerMethod('injection:complete');
        } else if (self.trigger) {
          self.trigger('injection:complete');
        }
      };

      if (inject.length > 0) {
        _done = _.after(inject.length, done);
      } else {
        done();
      }
      _.each(inject, function(name) {
        this.doInject(name, _done);
      }, this);
    },

    // grab a global singleton and register its
    doInject: function(name, done) {

      return SingletonRegistry.getAsync(name, function(instance) {
        var camelName =  name.slice(0, 1) + name.replace(splitter, function(match, prefix, section) {
          return section.toUpperCase();
        }).slice(1);
        this[camelName] = instance;
        if (this.triggerMethod) {
          this.triggerMethod('injected:' + name, instance);
        } else if (this.trigger) {
          this.trigger('injected:' + name, instance);
        }
        if (done) { done(); }
      }, this);
    }

  };

  return InjectMixin;
})
;
